module.exports = __webpack_public_path__ + "assets/bef7f66a4fb8332c04b677ce20cefcd6.jpg";